import { useState } from "react";
import { NavLink } from "react-router-dom";
import {
  FiActivity,
  FiBarChart2,
  FiBookOpen,
  FiChevronDown,
  FiClipboard,
  FiDollarSign,
  FiExternalLink,
  FiFileText,
  FiGrid,
  FiList,
  FiMenu,
  FiPackage,
  FiRefreshCw,
  FiShield,
  FiShoppingCart,
  FiTruck,
  FiUsers,
  FiX,
} from "react-icons/fi";
import "./Sidebar.css";

const navigationSections = [
  {
    label: "Workspace",
    items: [
      {
        label: "Piracy Check",
        icon: FiShield,
        href: "https://distributor.ssccglpinnacle.com",
        external: true,
      },
      { label: "Stock Status", icon: FiActivity, to: "/Orderstatus" },
      { label: "Student Coins", icon: FiDollarSign, to: "/CoinsCheck" },
      {
        label: "Book Status",
        icon: FiBookOpen,
        children: [
          { label: "Book Shelf Audit", to: "/Shelfaudit" },
          { label: "Book Life Cycle", to: "/BooklifeCycle" },
          { label: "Distributor Audit", to: "/DistributorAudit" },
          { label: "Date Wise SKU", to: "/" },
        ],
      },
    ],
  },
  {
    label: "Reports",
    items: [
      { label: "Log Activity", icon: FiActivity, to: "/Log" },
      { label: "MIS Report", icon: FiBarChart2, to: "/Viewdata" },
      { label: "Settlement", icon: FiDollarSign, to: "/Settlement" },
      {
        label: "Snapshots Data",
        icon: FiFileText,
        children: [
          { label: "Settlement Snapshot", to: "/SettlementSnapshot" },
          { label: "Purchase Snapshot", to: "/PurchaseSnapshot" },
        ],
      },
    ],
  },
  {
    label: "Partners",
    items: [
      {
        label: "Supplier Portal",
        icon: FiTruck,
        children: [
          {
            label: "Go To Supplier Portal",
            href: "http://vendor.ssccglpinnacle.com",
            external: true,
          },
          {
            label: "Purchase Book",
            icon: FiShoppingCart,
            children: [
              { label: "Create Purchase Order", to: "/POcreation" },
              { label: "Approve Purchase Order", to: "/ApprovePO" },
              { label: "Purchase Order Given", to: "/POgiven" },
              { label: "Generate Barcodes", to: "/Newserial" },
              { label: "Print Barcode", to: "/Hashing" },
              { label: "Records of Serial Number", to: "/SerialNumber" },
              { label: "SKU Wise Quantity", to: "/Purchasequantity" },
              { label: "Wrong Sticker Scan", to: "/Wrongsticker" },
              { label: "Generate Cancel Sticker", to: "/Cancelsticker" },
              { label: "Rejected Sticker", to: "/Rejectedsticker" },
              { label: "Extra Barcodes Record", to: "/BatchSearch" },
            ],
          },
          { label: "Hologram", to: "/Hologram" },
          { label: "Status Hologram", to: "/ManageHologram" },
        ],
      },
      {
        label: "Listing",
        icon: FiList,
        children: [
          { label: "Creating New Listing", to: "/Createlisting" },
          { label: "Manage Listing", to: "/Managelisting" },
        ],
      },
      {
        label: "Book Supplier",
        icon: FiTruck,
        children: [
          { label: "Manage Book Supplier", to: "/Managebooksupplier" },
        ],
      },
      {
        label: "Super Distributor",
        icon: FiUsers,
        children: [
          { label: "Create Distributor", to: "/Createsuperdistributor" },
          { label: "Manage Super Distributor", to: "/ManageSuperDist" },
        ],
      },
    ],
  },
  {
    label: "Inventory",
    items: [
      {
        label: "Inbound",
        icon: FiPackage,
        children: [
          { label: "Create GRN", to: "/CreateGRN" },
          { label: "Manage GRN", to: "/Goodreceivedbatches" },
          { label: "Create Shelf", to: "/CreateShelf" },
          { label: "Manage Shelf", to: "/Manageshelf" },
          { label: "Scan Inbound", to: "/ScanInbound" },
          { label: "Manage Inbound", to: "/Manageinbound" },
          { label: "Shelf Transfer", to: "/TransferBarcodes" },
        ],
      },
      {
        label: "Outbound",
        icon: FiTruck,
        children: [
          { label: "Purchase Order", to: "/Purchase" },
          { label: "Approve Order", to: "/ApproveDPO" },
          { label: "Create Shipment", to: "/CreateShipment" },
          { label: "Manage Shipments", to: "/Manageshipments" },
          { label: "Quick Outbound", to: "/Outbound" },
          { label: "B2C Sales", to: "/FlipkartPO" },
          { label: "Manage B2C Sales", to: "/ManageB2C" },
        ],
      },
      {
        label: "6th Edition",
        icon: FiGrid,
        children: [
          { label: "Scan Hashing", to: "/Scanhashing" },
          { label: "B2C Hashing", to: "/B2chashing" },
          { label: "Quick Hashing", to: "/Quickhash" },
          { label: "Outbound", to: "/CreateShipmentnew" },
        ],
      },
      {
        label: "Challan & Invoice",
        icon: FiClipboard,
        children: [
          { label: "Create Challan & Invoice", to: "/CreateInvoice" },
          { label: "Manage Challan", to: "/ManageChallan" },
        ],
      },
      {
        label: "Return",
        icon: FiRefreshCw,
        children: [
          { label: "Create Return GRN", to: "/Returngrn" },
          { label: "Manage Return Books", to: "/Managereturn" },
          { label: "Return Label New", to: "/ReturnLabel1" },
          { label: "Return Inbound", to: "/ReturnInbound" },
          { label: "Return Inbound New", to: "/ReturnInbound1" },
          { label: "Manage Return Inbound", to: "/ManageReturnInbound" },
          { label: "Sales Return Order", to: "/ManageCreditNote" },
        ],
      },
    ],
  },
];

function NavigationEntry({ item, depth = 0, onNavigate }) {
  const Icon = item.icon;

  if (item.children) {
    return (
      <details className={"inventory-sidebar__group inventory-sidebar__group--" + depth}>
        <summary className="inventory-sidebar__group-trigger">
          {Icon ? (
            <Icon className="inventory-sidebar__icon" aria-hidden="true" />
          ) : (
            <span className="inventory-sidebar__subitem-mark" aria-hidden="true" />
          )}
          <span className="inventory-sidebar__label">{item.label}</span>
          <FiChevronDown
            className="inventory-sidebar__chevron"
            aria-hidden="true"
          />
        </summary>
        <div className="inventory-sidebar__children">
          {item.children.map((child) => (
            <NavigationEntry
              key={child.to || child.href || child.label}
              item={child}
              depth={depth + 1}
              onNavigate={onNavigate}
            />
          ))}
        </div>
      </details>
    );
  }

  if (item.external) {
    return (
      <a
        className={
          "inventory-sidebar__link inventory-sidebar__link--depth-" + depth
        }
        href={item.href}
        target="_blank"
        rel="noopener noreferrer"
        onClick={onNavigate}
      >
        {Icon ? (
          <Icon className="inventory-sidebar__icon" aria-hidden="true" />
        ) : (
          <span className="inventory-sidebar__subitem-mark" aria-hidden="true" />
        )}
        <span className="inventory-sidebar__label">{item.label}</span>
        <FiExternalLink
          className="inventory-sidebar__external"
          aria-hidden="true"
        />
      </a>
    );
  }

  return (
    <NavLink
      className={({ isActive }) =>
        "inventory-sidebar__link inventory-sidebar__link--depth-" +
        depth +
        (isActive ? " is-active" : "")
      }
      to={item.to}
      end
      onClick={onNavigate}
    >
      {Icon ? (
        <Icon className="inventory-sidebar__icon" aria-hidden="true" />
      ) : (
        <span className="inventory-sidebar__subitem-mark" aria-hidden="true" />
      )}
      <span className="inventory-sidebar__label">{item.label}</span>
    </NavLink>
  );
}

function SideBar() {
  const [mobileOpen, setMobileOpen] = useState(false);

  const closeMobileNavigation = () => setMobileOpen(false);

  return (
    <aside
      className={
        "inventory-sidebar" + (mobileOpen ? " inventory-sidebar--open" : "")
      }
      aria-label="Inventory navigation"
    >
      <div className="inventory-sidebar__inner">
        <div className="inventory-sidebar__brand">
          <div className="inventory-sidebar__brand-mark" aria-hidden="true">
            P
          </div>
          <div className="inventory-sidebar__brand-copy">
            <span className="inventory-sidebar__brand-name">Pinnacle</span>
            <span className="inventory-sidebar__brand-caption">
              Inventory portal
            </span>
          </div>
          <button
            className="inventory-sidebar__mobile-toggle"
            type="button"
            aria-label={mobileOpen ? "Close navigation" : "Open navigation"}
            aria-expanded={mobileOpen}
            onClick={() => setMobileOpen((isOpen) => !isOpen)}
          >
            {mobileOpen ? <FiX aria-hidden="true" /> : <FiMenu aria-hidden="true" />}
          </button>
        </div>

        <div className="inventory-sidebar__body">
          <nav className="inventory-sidebar__nav">
            {navigationSections.map((section) => (
              <section
                className="inventory-sidebar__section"
                key={section.label}
                aria-label={section.label}
              >
                <h2 className="inventory-sidebar__section-title">
                  {section.label}
                </h2>
                <div className="inventory-sidebar__section-items">
                  {section.items.map((item) => (
                    <NavigationEntry
                      key={item.to || item.href || item.label}
                      item={item}
                      onNavigate={closeMobileNavigation}
                    />
                  ))}
                </div>
              </section>
            ))}
          </nav>


        </div>
      </div>
    </aside>
  );
}

export default SideBar;
